/* eslint-disable */
import * as v1 from "./m2m-users.v1";
export const m2mUsers = { v1 };
